// Machines page (#/machines): shared pool of unclaimed PCs + the user's claimed machines with their
// game-account slots (license, hunt settings, auto-launch, live character). Admin "view as" is honored
// through App.api's automatic user_id injection on GET lists.
'use strict';
(function () {
  const App = window.App;
  const t = App.t, esc = App.esc, api = App.api;

  App.i18n.add({
    ko: {
      mach_desc: 'PC를 가져와 게임 계정을 등록하고, 라이선스와 사냥 설정을 연결하세요.',
      mach_step1_t: 'PC 가져오기', mach_step1_d: '공유풀에 올라온 PC를 내 머신으로 가져옵니다.',
      mach_step2_t: '게임 계정 추가', mach_step2_d: '머신에 게임 계정(슬롯)을 추가하면 자동 실행을 관리할 수 있습니다.',
      mach_step3_t: '라이선스·사냥 설정', mach_step3_d: '슬롯에 라이선스를 연결하고 사냥 설정을 지정하면 준비 완료입니다.',
      mach_pool_title: '공유풀 (대기 중인 PC)', mach_pool_desc: '드라이버가 실행된 PC가 여기에 나타납니다. 먼저 가져온 사람이 사용합니다.',
      mach_pool_empty: '현재 대기 중인 PC가 없습니다.', mach_pool_pending: '대기 중',
      mach_attempts: '시도 {0}회', mach_first_seen: '처음 감지 {0}', mach_last_seen: '마지막 감지 {0}',
      mach_claim: '내 머신으로 가져오기', mach_claim_title: '내 머신으로 가져오기',
      mach_claim_desc: '이 PC를 내 머신으로 등록합니다. 드라이버 승인이 즉시 완료되고, 이후 게임 계정(슬롯)을 추가해 자동 실행과 사냥 설정을 관리할 수 있습니다.',
      mach_claim_btn: '가져오기', mach_claimed: '머신을 가져왔습니다.',
      mach_dismiss: '목록에서 제거', mach_dismiss_confirm: '이 PC를 공유풀에서 제거할까요? 드라이버가 다시 요청하면 목록에 다시 나타납니다.',
      mach_dismissed: '목록에서 제거했습니다.',
      mach_mine_title: '내 머신', mach_mine_empty_title: '아직 머신이 없습니다',
      mach_mine_empty_pool: '위 공유풀에서 PC를 가져와 시작하세요.',
      mach_mine_empty_none: 'PC에서 드라이버를 실행하면 위 공유풀에 나타납니다. 그 PC를 가져오세요.',
      mach_online: '온라인', mach_offline: '오프라인', mach_rename: '별칭 변경', mach_renamed: '별칭을 변경했습니다.',
      mach_add_slot: '계정 추가', mach_no_slots: '등록된 게임 계정이 없습니다.',
      mach_release: '머신 내보내기',
      mach_release_confirm: '‘{0}’ 머신을 내보낼까요? 슬롯 {1}개가 삭제되고 연결된 라이선스는 미사용 상태로 돌아갑니다.',
      mach_release_detail: '드라이버 승인이 해제되어 PC가 공유풀로 돌아가며, 실행 중인 게임 연결이 끊어집니다.',
      mach_released: '머신을 내보냈습니다.',
      mach_alias: '별칭', mach_alias_ph: '예: 사무실 PC',
      mach_detected: '새 계정 감지: {0}', mach_detected_add: '슬롯으로 추가',
      mach_diag_none: '진단 정보 없음', mach_diag_cores: '{0}코어', mach_diag_ram: 'RAM {0}/{1}GB', mach_diag_cpu: 'CPU {0}%',
      mach_autolaunch: '자동 실행', mach_autolaunch_on: '자동 실행을 켰습니다.', mach_autolaunch_off: '자동 실행을 껐습니다.',
      mach_has_password: '비밀번호 설정됨', mach_no_password: '비밀번호 없음', mach_no_password_hint: '비밀번호가 없어 자동 실행에 사용할 수 없습니다.',
      mach_mode_custom: '맞춤 설정', mach_mode_template: '프로필: {0}', mach_mode_default: '기본 프로필',
      mach_char_level: 'Lv.{0}', mach_no_char: '캐릭터 없음',
      mach_edit: '수정', mach_lic_action: '라이선스', mach_hunt: '사냥 설정', mach_delete_slot: '삭제',
      mach_delete_slot_confirm: '‘{0}’ 슬롯을 삭제할까요?', mach_delete_slot_lic_detail: '연결된 라이선스는 미사용 상태로 돌아갑니다.',
      mach_slot_deleted: '슬롯을 삭제했습니다.',
      mach_slot_add_title: '게임 계정 추가', mach_slot_edit_title: '슬롯 수정',
      mach_f_account: '게임 계정 (이메일)', mach_f_account_hint: '게임에 로그인하는 계정 이메일입니다.',
      mach_f_server: '서버', mach_f_nickname: '닉네임', mach_f_nickname_hint: '자동 입장할 캐릭터 이름', mach_f_note: '메모',
      mach_f_enabled: '자동 실행 사용',
      mach_f_password: '비밀번호',
      mach_pw_add_ph: '자동 실행 비밀번호 (선택)', mach_pw_new_ph: '새 비밀번호',
      mach_pw_keep: '변경 안 함', mach_pw_set: '새로 설정', mach_pw_clear: '삭제',
      mach_pw_current_set: '현재: 비밀번호 설정됨', mach_pw_current_none: '현재: 비밀번호 없음',
      mach_pw_hint: '게임이 꺼져 있을 때 자동 실행 로그인에 사용되며, 저장 후에는 다시 볼 수 없습니다.',
      mach_keep_note: '계정·서버·닉네임을 바꿔도 이 슬롯의 라이선스와 사냥 설정은 그대로 유지됩니다.',
      mach_add_note: '라이선스와 사냥 설정은 계정을 만든 뒤 연결·지정합니다.',
      mach_slot_added: '게임 계정을 추가했습니다.', mach_slot_saved: '슬롯을 저장했습니다.',
      mach_v_account_required: '게임 계정 이메일을 입력하세요.', mach_v_account_email: '올바른 이메일 형식이 아닙니다.',
      mach_v_password_required: '새 비밀번호를 입력하세요.',
      mach_lic_pick_title: '라이선스 연결', mach_lic_pick_desc: '이 슬롯에 연결할 라이선스를 선택하세요.',
      mach_lic_connect: '라이선스 연결', mach_lic_move_here: '이 슬롯으로 이동', mach_lic_unbind: '연결 해제',
      mach_lic_on_this: '이 슬롯에 연결됨', mach_lic_on_this_badge: '연결됨',
      mach_lic_on_other_at: '다른 슬롯에 연결됨 · {0} · {1} (연결하면 이동)',
      mach_lic_current_slot: '현재 이 슬롯에 연결된 라이선스',
      mach_lic_none_available: '사용할 수 있는 라이선스가 없습니다.', mach_lic_go: '라이선스 등록하러 가기',
      mach_lic_bound_ok: '라이선스를 연결했습니다.', mach_lic_moved: '다른 슬롯에서 이동해 연결했습니다.',
      mach_lic_unbound: '라이선스 연결을 해제했습니다.',
      mach_viewas_claim_disabled: '다른 사용자 화면에서는 PC를 가져올 수 없습니다.',
      mach_e_already_claimed: '이미 다른 사용자가 가져간 PC입니다.',
      mach_e_slot_exists: '이 머신에 같은 게임 계정 슬롯이 이미 있습니다.',
      mach_e_license_not_owned: '내 라이선스가 아닙니다.',
      mach_e_license_revoked: '회수된 라이선스는 연결할 수 없습니다.',
      mach_e_license_expired: '만료된 라이선스는 연결할 수 없습니다.',
      mach_auto_label: '자동 실행',
      mach_auto_driver_offline: '드라이버 오프라인',
      mach_auto_not_configured: '관리자가 자동 실행 설정을 아직 하지 않음',
      mach_auto_disabled: '자동 실행이 꺼져 있음',
      mach_auto_no_slots: '비밀번호가 있는 활성 계정이 없음',
      mach_auto_no_slots_hint: '계정에 비밀번호를 설정하면 자동 실행됩니다.',
      mach_auto_full: '최대 {0}개 실행 중',
      mach_auto_waiting_confirm: '방금 실행한 계정의 게임 시작 확인 중',
      mach_auto_launching: '게임을 실행하는 중',
      mach_auto_cooldown: '실패가 반복되어 {0}까지 대기',
      mach_auto_cooldown_wait: '실패가 반복되어 대기 중',
      mach_auto_idle: '대기 중 (실행할 계정 없음)',
      mach_auto_running: '실행 중',
      mach_in_now: '곧', mach_in_secs: '{0}초 후', mach_in_mins: '{0}분 후', mach_in_hours: '{0}시간 후',
      mach_sa_off: '자동 꺼짐', mach_sa_no_password: '비밀번호 필요', mach_sa_queued: '실행 대기열',
      mach_sa_launching: '실행 시작 중', mach_sa_running: '실행 중',
      mach_sa_cooldown: '재시도 대기 ({0})', mach_sa_cooldown_wait: '재시도 대기', mach_sa_over_limit: '대기 (한도 초과)',
      mach_sa_error: '오류',
      mach_move_up: '위로', mach_move_down: '아래로', mach_order_saved: '순서를 변경했습니다.',
      mach_order_hint: '자동 실행은 머신당 최대 {0}개, 위에서부터 순서대로 실행됩니다.'
    },
    'zh-CN': {
      mach_desc: '获取 PC 后登记游戏账号，再连接授权与狩猎设置。',
      mach_step1_t: '获取 PC', mach_step1_d: '从共享池获取已上线的 PC 作为我的机器。',
      mach_step2_t: '添加游戏账号', mach_step2_d: '在机器上添加游戏账号（槽位）即可管理自动启动。',
      mach_step3_t: '授权与狩猎设置', mach_step3_d: '为槽位连接授权并指定狩猎设置即完成。',
      mach_pool_title: '共享池（等待中的 PC）', mach_pool_desc: '已运行驱动的 PC 会出现在这里，先获取者可使用。',
      mach_pool_empty: '当前没有等待中的 PC。', mach_pool_pending: '等待中',
      mach_attempts: '尝试 {0} 次', mach_first_seen: '首次检测 {0}', mach_last_seen: '最后检测 {0}',
      mach_claim: '获取为我的机器', mach_claim_title: '获取为我的机器',
      mach_claim_desc: '将此 PC 登记为我的机器。驱动审批会立即完成，之后可添加游戏账号（槽位）来管理自动启动与狩猎设置。',
      mach_claim_btn: '获取', mach_claimed: '已获取机器。',
      mach_dismiss: '从列表移除', mach_dismiss_confirm: '要从共享池移除此 PC 吗？驱动再次请求时会重新出现。',
      mach_dismissed: '已从列表移除。',
      mach_mine_title: '我的机器', mach_mine_empty_title: '还没有机器',
      mach_mine_empty_pool: '请从上方共享池获取 PC 开始。',
      mach_mine_empty_none: '在 PC 上运行驱动后会出现在上方共享池，请获取该 PC。',
      mach_online: '在线', mach_offline: '离线', mach_rename: '修改别名', mach_renamed: '已修改别名。',
      mach_add_slot: '添加账号', mach_no_slots: '尚未登记游戏账号。',
      mach_release: '导出机器',
      mach_release_confirm: '要导出机器“{0}”吗？将删除 {1} 个槽位，其授权会回到未使用状态。',
      mach_release_detail: '驱动审批将被解除，PC 回到共享池，正在运行的游戏连接会被断开。',
      mach_released: '已导出机器。',
      mach_alias: '别名', mach_alias_ph: '例如：办公室 PC',
      mach_detected: '检测到新账号：{0}', mach_detected_add: '添加为槽位',
      mach_diag_none: '无诊断信息', mach_diag_cores: '{0} 核', mach_diag_ram: '内存 {0}/{1}GB', mach_diag_cpu: 'CPU {0}%',
      mach_autolaunch: '自动启动', mach_autolaunch_on: '已开启自动启动。', mach_autolaunch_off: '已关闭自动启动。',
      mach_has_password: '已设置密码', mach_no_password: '无密码', mach_no_password_hint: '未设置密码，无法用于自动启动。',
      mach_mode_custom: '自定义设置', mach_mode_template: '方案：{0}', mach_mode_default: '默认方案',
      mach_char_level: 'Lv.{0}', mach_no_char: '无角色',
      mach_edit: '修改', mach_lic_action: '授权', mach_hunt: '狩猎设置', mach_delete_slot: '删除',
      mach_delete_slot_confirm: '要删除槽位“{0}”吗？', mach_delete_slot_lic_detail: '连接的授权会回到未使用状态。',
      mach_slot_deleted: '已删除槽位。',
      mach_slot_add_title: '添加游戏账号', mach_slot_edit_title: '修改槽位',
      mach_f_account: '游戏账号（邮箱）', mach_f_account_hint: '用于登录游戏的账号邮箱。',
      mach_f_server: '服务器', mach_f_nickname: '昵称', mach_f_nickname_hint: '自动进入的角色名', mach_f_note: '备注',
      mach_f_enabled: '启用自动启动',
      mach_f_password: '密码',
      mach_pw_add_ph: '自动启动密码（可选）', mach_pw_new_ph: '新密码',
      mach_pw_keep: '不修改', mach_pw_set: '重新设置', mach_pw_clear: '删除',
      mach_pw_current_set: '当前：已设置密码', mach_pw_current_none: '当前：无密码',
      mach_pw_hint: '游戏关闭时用于自动启动登录，保存后无法再次查看。',
      mach_keep_note: '修改账号·服务器·昵称不会影响此槽位的授权与狩猎设置。',
      mach_add_note: '授权与狩猎设置将在创建账号后连接·指定。',
      mach_slot_added: '已添加游戏账号。', mach_slot_saved: '已保存槽位。',
      mach_v_account_required: '请输入游戏账号邮箱。', mach_v_account_email: '邮箱格式不正确。',
      mach_v_password_required: '请输入新密码。',
      mach_lic_pick_title: '连接授权', mach_lic_pick_desc: '选择要连接到此槽位的授权。',
      mach_lic_connect: '连接授权', mach_lic_move_here: '移动到此槽位', mach_lic_unbind: '解除连接',
      mach_lic_on_this: '已连接到此槽位', mach_lic_on_this_badge: '已连接',
      mach_lic_on_other_at: '已连接到其他槽位 · {0} · {1}（连接后将移动）',
      mach_lic_current_slot: '当前连接到此槽位的授权',
      mach_lic_none_available: '没有可用的授权。', mach_lic_go: '前往登记授权',
      mach_lic_bound_ok: '已连接授权。', mach_lic_moved: '已从其他槽位移动并连接。',
      mach_lic_unbound: '已解除授权连接。',
      mach_viewas_claim_disabled: '在其他用户界面下无法获取 PC。',
      mach_e_already_claimed: '该 PC 已被其他用户获取。',
      mach_e_slot_exists: '此机器上已存在相同游戏账号的槽位。',
      mach_e_license_not_owned: '不是我的授权。',
      mach_e_license_revoked: '已收回的授权无法连接。',
      mach_e_license_expired: '已过期的授权无法连接。',
      mach_auto_label: '自动启动',
      mach_auto_driver_offline: '驱动离线',
      mach_auto_not_configured: '管理员尚未设置自动启动',
      mach_auto_disabled: '自动启动已关闭',
      mach_auto_no_slots: '没有设置密码的启用账号',
      mach_auto_no_slots_hint: '为账号设置密码后即可自动启动。',
      mach_auto_full: '已运行上限 {0} 个',
      mach_auto_waiting_confirm: '正在确认刚启动账号的游戏是否开始',
      mach_auto_launching: '正在启动游戏',
      mach_auto_cooldown: '多次失败，等待至 {0}',
      mach_auto_cooldown_wait: '多次失败，等待中',
      mach_auto_idle: '空闲（没有可启动的账号）',
      mach_auto_running: '运行中',
      mach_in_now: '即将', mach_in_secs: '{0} 秒后', mach_in_mins: '{0} 分钟后', mach_in_hours: '{0} 小时后',
      mach_sa_off: '自动关闭', mach_sa_no_password: '需要密码', mach_sa_queued: '排队中',
      mach_sa_launching: '正在启动', mach_sa_running: '运行中',
      mach_sa_cooldown: '等待重试（{0}）', mach_sa_cooldown_wait: '等待重试', mach_sa_over_limit: '等待（超出上限）',
      mach_sa_error: '错误',
      mach_move_up: '上移', mach_move_down: '下移', mach_order_saved: '已调整顺序。',
      mach_order_hint: '自动启动每台机器最多 {0} 个，从上到下依次启动。'
    }
  });

  const hashShort = (h) => h ? (String(h).slice(0, 12) + '…') : '—';
  const gb = (mb) => mb ? (Number(mb) / 1024).toFixed(1) : '0';
  const apiError = (r, overrides) => {
    const code = r && r.data && r.data.err;
    return code && overrides && overrides[code] ? t(overrides[code]) : App.errorText(r && r.data);
  };
  const MA_TONE = { driver_offline: 'bad', not_configured: 'neutral', disabled: 'neutral', no_slots: 'warn', full: 'ok', waiting_confirm: 'warn', launching: 'info', cooldown: 'bad', idle: 'neutral' };
  const SA_TONE = { off: 'neutral', no_password: 'warn', queued: 'info', launching: 'info', running: 'ok', cooldown: 'bad', over_limit: 'warn' };
  function relUntil(ts) {
    const s = (Number(ts) - Date.now()) / 1000;
    if (s <= 5) return t('mach_in_now');
    if (s < 60) return t('mach_in_secs', Math.round(s));
    if (s < 3600) return t('mach_in_mins', Math.round(s / 60));
    return t('mach_in_hours', Math.round(s / 3600));
  }

  App.page('machines', {
    title: () => t('nav_machines'),
    nav: { group: 'main', order: 20, icon: '🖥' },
    render(root) {
      const wrap = document.createElement('div');
      wrap.className = 'page';
      root.appendChild(wrap);
      const state = { pool: [], machines: [], loaded: false };

      const findSlot = (sid) => {
        for (const m of state.machines) for (const s of (m.slots || [])) if (s.id === sid) return s;
        return null;
      };

      const current = () => document.body.contains(wrap);

      skeleton();
      reload();

      const offRoster = App.ws.on('roster', reload);
      const offStates = App.ws.on('states', onStates);
      wrap.addEventListener('click', onClick);
      wrap.addEventListener('change', onChange);
      // Auto-launch statuses change without WS events, so poll while the page is open.
      const timer = setInterval(() => {
        if (document.querySelector('.dialog-back')) return;
        const ae = document.activeElement;
        if (ae && wrap.contains(ae) && /^(INPUT|SELECT|TEXTAREA)$/.test(ae.tagName)) return;
        reload();
      }, 10000);

      return () => { clearInterval(timer); offRoster(); offStates(); App.ws.subscribe([]); };

      // ── data ──
      async function reload() {
        try {
          const [pm, mm] = await Promise.all([api('/api/machine-pool'), api('/api/machines')]);
          if (!current()) return;
          state.pool = (pm.data && pm.data.pool) || [];
          state.machines = (mm.data && mm.data.machines) || [];
          state.loaded = true;
          App.setNavCount('machines', state.pool.length);
          const ids = [];
          for (const m of state.machines) for (const s of (m.slots || [])) if (s.character) ids.push(s.character.id);
          App.ws.subscribe(ids);
          paint();
        } catch (error) { console.error(error); if (current()) errorState(); }
      }

      function onStates(msg) {
        if (!msg || !Array.isArray(msg.states)) return;
        for (const st of msg.states) {
          const dot = wrap.querySelector(`[data-live-dot="${st.character_id}"]`);
          if (dot) dot.className = 'dot' + (st.online ? ' ok' : '');
          if (st.level != null) { const lv = wrap.querySelector(`[data-live-lv="${st.character_id}"]`); if (lv) lv.textContent = t('mach_char_level', st.level); }
        }
      }

      // ── rendering ──
      function skeleton() {
        wrap.innerHTML = head() + `<div class="stack"><div class="skeleton" style="height:90px"></div><div class="skeleton" style="height:150px"></div></div>`;
      }
      function errorState() {
        wrap.innerHTML = head() + `<div class="empty-state"><div class="empty-icon">⚠️</div><p>${esc(t('e_fail'))}</p><button class="btn secondary" data-act="refresh">${esc(t('retry'))}</button></div>`;
      }
      function head() {
        return `<div class="page-head"><div class="titles"><h1>${esc(t('nav_machines'))}</h1><p class="desc">${esc(t('mach_desc'))}</p></div>
          <div class="actions"><button class="btn secondary sm" data-act="refresh">${esc(t('refresh'))}</button></div></div>`;
      }
      function paint() {
        const isAdmin = App.me && App.me.role === 'admin';
        const viewAs = !!App.viewAs;
        const pool = state.pool, machines = state.machines;
        wrap.innerHTML = head() + guide() + `
          <section class="section">
            <div class="section-head"><h2>${esc(t('mach_pool_title'))}</h2><span class="badge info">${pool.length}</span><p class="desc">${esc(t('mach_pool_desc'))}</p></div>
            ${pool.length ? `<div class="stack tight">${pool.map((p) => poolRow(p, isAdmin, viewAs)).join('')}</div>` : `<div class="panel muted small">${esc(t('mach_pool_empty'))}</div>`}
          </section>
          <section class="section">
            <div class="section-head"><h2>${esc(t('mach_mine_title'))}</h2><span class="badge neutral">${machines.length}</span></div>
            ${machines.length ? `<div class="stack">${machines.map(machineCard).join('')}</div>` : emptyMine(pool.length)}
          </section>`;
      }
      function guide() {
        const steps = [['①', t('mach_step1_t'), t('mach_step1_d')], ['②', t('mach_step2_t'), t('mach_step2_d')], ['③', t('mach_step3_t'), t('mach_step3_d')]];
        return `<div class="card"><div class="card-body"><div class="row" style="align-items:stretch">${steps.map(([n, tt, dd]) =>
          `<div class="panel grow"><div class="small"><b>${n} ${esc(tt)}</b></div><div class="small muted">${esc(dd)}</div></div>`).join('')}</div></div></div>`;
      }
      function emptyMine(poolLen) {
        return `<div class="empty-state"><div class="empty-icon">🖥</div><p>${esc(t('mach_mine_empty_title'))}</p>
          <p class="small muted">${esc(poolLen ? t('mach_mine_empty_pool') : t('mach_mine_empty_none'))}</p></div>`;
      }
      function poolRow(p, isAdmin, viewAs) {
        return `<div class="card"><div class="card-body row between">
          <div class="grow">
            <div class="row"><span class="mono">${esc(hashShort(p.pc_hash))}</span><span class="badge warn">${esc(t('mach_pool_pending'))}</span><span class="small muted">${esc(t('mach_attempts', p.attempts || 1))}</span></div>
            <div class="small muted">${esc(t('mach_first_seen', App.fmt.rel(p.first_seen)))} <span class="faint">·</span> ${esc(t('mach_last_seen', App.fmt.rel(p.last_seen)))}</div>
          </div>
          <div class="actions">
            ${viewAs ? `<span class="small faint">${esc(t('mach_viewas_claim_disabled'))}</span>`
              : `<button class="btn primary sm" data-act="claim" data-hash="${esc(p.pc_hash)}">${esc(t('mach_claim'))}</button>`}
            ${isAdmin ? `<button class="btn ghost sm" data-act="dismiss" data-hash="${esc(p.pc_hash)}">${esc(t('mach_dismiss'))}</button>` : ''}
          </div>
        </div></div>`;
      }
      function diagSummary(d) {
        if (!d) return `<div class="small muted">${esc(t('mach_diag_none'))}</div>`;
        const parts = [];
        if (d.os) parts.push(esc(d.os));
        if (d.cpu) parts.push(esc(d.cpu) + (d.cores != null ? ' (' + esc(t('mach_diag_cores', d.cores)) + ')' : ''));
        else if (d.cores != null) parts.push(esc(t('mach_diag_cores', d.cores)));
        if (d.ram_total_mb) parts.push(esc(t('mach_diag_ram', gb(d.ram_used_mb), gb(d.ram_total_mb))));
        if (d.cpu_pct != null) parts.push(esc(t('mach_diag_cpu', Math.round(d.cpu_pct))));
        if (d.ip) parts.push(esc(d.ip));
        if (d.locale) parts.push(esc(d.locale));
        return parts.length ? `<div class="row small muted">${parts.map((p) => `<span>${p}</span>`).join('<span class="faint">·</span>')}</div>`
          : `<div class="small muted">${esc(t('mach_diag_none'))}</div>`;
      }
      function machineAutoLine(m) {
        const a = m.auto;
        if (!a) return '';
        const tone = MA_TONE[a.status] || 'neutral';
        let text;
        if (a.status === 'full') text = t('mach_auto_full', a.max_clients != null ? a.max_clients : 2);
        else if (a.status === 'cooldown') text = a.next_at ? t('mach_auto_cooldown', relUntil(a.next_at)) : t('mach_auto_cooldown_wait');
        else text = t('mach_auto_' + a.status);
        const running = (a.running && a.running.length)
          ? `<span class="small muted">${esc(t('mach_auto_running'))}: ${a.running.map((r) => esc((r.game_account || '—') + ' · pid ' + r.pid)).join(', ')}</span>` : '';
        const hint = a.status === 'no_slots' ? `<span class="small faint">${esc(t('mach_auto_no_slots_hint'))}</span>` : '';
        const detail = a.detail ? `<div class="small faint">${esc(a.detail)}</div>` : '';
        return `<div class="row small"><span class="muted">${esc(t('mach_auto_label'))}:</span><span class="badge ${tone}">${esc(text)}</span>${running}${hint}</div>${detail}`;
      }
      function machineCard(m) {
        const maxc = (m.auto && m.auto.max_clients != null) ? m.auto.max_clients : 2;
        const enabledCount = (m.slots || []).filter((s) => s.enabled).length;
        const orderHint = enabledCount > maxc ? `<div class="banner info"><span aria-hidden="true">↕️</span><span>${esc(t('mach_order_hint', maxc))}</span></div>` : '';
        const detected = (m.detected || []).map((d) =>
          `<div class="banner warn"><span aria-hidden="true">👤</span><div class="grow"><div>${esc(t('mach_detected', d.email))}</div>
            <div class="small muted">${esc(t('mach_last_seen', App.fmt.rel(d.last_seen)))} <span class="faint">·</span> ${esc(t('mach_attempts', d.attempts || 1))}</div></div>
            <button class="btn sm secondary" data-act="add-slot" data-mid="${m.id}" data-email="${esc(d.email)}">${esc(t('mach_detected_add'))}</button></div>`).join('');
        const list = (m.slots || []);
        const slots = list.length ? list.map((s, i) => slotRow(s, i, list)).join('')
          : `<div class="empty-state" style="padding:20px"><p class="small">${esc(t('mach_no_slots'))}</p><button class="btn secondary sm" data-act="add-slot" data-mid="${m.id}">${esc(t('mach_add_slot'))}</button></div>`;
        return `<div class="card">
          <div class="card-head">
            <span class="dot${m.online ? ' ok' : ''}" title="${esc(m.online ? t('mach_online') : t('mach_offline'))}"></span>
            <div class="grow">
              <div class="row m-label"><h3>${esc(m.label)}</h3><button class="btn sm ghost icon" data-act="rename" data-mid="${m.id}" aria-label="${esc(t('mach_rename'))}" title="${esc(t('mach_rename'))}">✎</button></div>
              <div class="small muted">${m.hostname ? esc(m.hostname) + ' <span class="faint">·</span> ' : ''}<span class="mono">${esc(hashShort(m.pc_hash))}</span></div>
            </div>
            <div class="actions">
              <button class="btn sm secondary" data-act="add-slot" data-mid="${m.id}">${esc(t('mach_add_slot'))}</button>
              <button class="btn sm danger" data-act="release" data-mid="${m.id}">${esc(t('mach_release'))}</button>
            </div>
          </div>
          <div class="card-body stack">${diagSummary(m.diag)}${machineAutoLine(m)}${detected}${orderHint}<div class="stack tight">${slots}</div></div>
        </div>`;
      }
      function slotRow(s, idx, list) {
        const lic = s.license ? App.licenseBadge(s.license)
          : `<button class="btn sm secondary" data-act="license" data-sid="${s.id}">${esc(t('mach_lic_connect'))}</button>`;
        const mode = s.settings_mode === 'custom' ? t('mach_mode_custom')
          : s.settings_mode === 'template' ? t('mach_mode_template', s.template_name || '') : t('mach_mode_default');
        const pw = s.has_password ? `<span class="badge ok">🔒 ${esc(t('mach_has_password'))}</span>`
          : `<span class="badge neutral" title="${esc(t('mach_no_password_hint'))}">${esc(t('mach_no_password'))}</span>`;
        const ch = s.character;
        const live = ch
          ? `<span class="row tight"><span class="dot${ch.online ? ' ok' : ''}" data-live-dot="${ch.id}"></span><a href="#/char/${ch.id}">${esc(ch.name || '')}</a> <span data-live-lv="${ch.id}">${esc(t('mach_char_level', ch.level != null ? ch.level : 0))}</span></span>`
          : `<span class="small faint">${esc(t('mach_no_char'))}</span>`;
        const nameLine = s.nickname
          ? `<span>·</span><span>${esc(s.nickname)}${s.server_name ? '@' + esc(s.server_name) : ''}</span>`
          : (s.server_name ? `<span>·</span><span>@${esc(s.server_name)}</span>` : '');
        const sa = s.auto;
        let autoBadge = '';
        if (sa) {
          const tone = SA_TONE[sa.status] || 'neutral';
          const txt = sa.status === 'cooldown' ? (sa.next_at ? t('mach_sa_cooldown', relUntil(sa.next_at)) : t('mach_sa_cooldown_wait')) : t('mach_sa_' + sa.status);
          autoBadge = `<span class="badge ${tone}"${sa.last_error ? ` title="${esc(sa.last_error)}"` : ''}>${esc(txt)}</span>`;
        }
        const errLine = sa && sa.last_error ? `<div class="small bad truncate" title="${esc(sa.last_error)}">${esc(t('mach_sa_error'))}: ${esc(sa.last_error)}</div>` : '';
        return `<div class="panel stack tight">
          <div class="row between">
            <div class="grow stack tight">
              <div class="row"><span class="mono">${esc(s.game_account)}</span>${nameLine}${lic}${autoBadge}</div>
              <div class="row small muted">${esc(mode)}<span class="faint">·</span>${pw}<span class="faint">·</span>${live}</div>
              ${errLine}
            </div>
            <label class="switch"><input type="checkbox" data-toggle="${s.id}"${s.enabled ? ' checked' : ''}><span class="small">${esc(t('mach_autolaunch'))}</span></label>
          </div>
          <div class="row">
            <button class="btn sm ghost icon" data-act="move-up" data-sid="${s.id}"${idx === 0 ? ' disabled' : ''} aria-label="${esc(t('mach_move_up'))}" title="${esc(t('mach_move_up'))}">↑</button>
            <button class="btn sm ghost icon" data-act="move-down" data-sid="${s.id}"${idx === list.length - 1 ? ' disabled' : ''} aria-label="${esc(t('mach_move_down'))}" title="${esc(t('mach_move_down'))}">↓</button>
            <button class="btn sm ghost" data-act="edit-slot" data-sid="${s.id}">${esc(t('mach_edit'))}</button>
            <button class="btn sm ghost" data-act="license" data-sid="${s.id}">${esc(t('mach_lic_action'))}</button>
            <button class="btn sm ghost" data-act="hunt" data-sid="${s.id}">${esc(t('mach_hunt'))}</button>
            <button class="btn sm ghost" data-act="delete-slot" data-sid="${s.id}">${esc(t('mach_delete_slot'))}</button>
          </div>
        </div>`;
      }

      // ── events ──
      function onChange(e) {
        const toggle = e.target.closest('[data-toggle]');
        if (toggle) toggleEnabled(Number(toggle.dataset.toggle), toggle.checked, toggle);
      }
      function onClick(e) {
        const btn = e.target.closest('[data-act]');
        if (!btn) return;
        const sid = btn.dataset.sid ? Number(btn.dataset.sid) : null;
        const mid = btn.dataset.mid ? Number(btn.dataset.mid) : null;
        switch (btn.dataset.act) {
          case 'refresh': skeleton(); reload(); break;
          case 'claim': openClaim(btn.dataset.hash); break;
          case 'dismiss': dismiss(btn.dataset.hash); break;
          case 'rename': startRename(mid, btn); break;
          case 'rename-save': saveRename(mid, btn.closest('.m-label').querySelector('input').value); break;
          case 'rename-cancel': paint(); break;
          case 'add-slot': slotDialog({ mid, slot: null, email: btn.dataset.email || '' }); break;
          case 'release': releaseMachine(mid); break;
          case 'edit-slot': { const s = findSlot(sid); if (s) slotDialog({ mid: s.machine_id, slot: s }); break; }
          case 'license': { const s = findSlot(sid); if (s) openLicensePicker(s); break; }
          case 'hunt': App.navigate('#/slot-settings/' + sid); break;
          case 'delete-slot': deleteSlot(sid); break;
          case 'move-up': moveSlot(sid, -1); break;
          case 'move-down': moveSlot(sid, 1); break;
        }
      }

      async function toggleEnabled(sid, enabled, input) {
        input.disabled = true;
        const r = await api('/api/slots/' + sid, { method: 'PUT', body: { enabled } });
        input.disabled = false;
        if (!r.ok) { input.checked = !enabled; App.toast(App.errorText(r.data), 'error'); return; }
        const s = findSlot(sid); if (s) s.enabled = enabled;
        App.toast(enabled ? t('mach_autolaunch_on') : t('mach_autolaunch_off'));
      }

      async function moveSlot(sid, dir) {
        const s = findSlot(sid);
        if (!s) return;
        const m = state.machines.find((x) => x.id === s.machine_id);
        if (!m) return;
        const list = (m.slots || []).slice().sort((a, b) => (a.sort_index - b.sort_index) || (a.id - b.id));
        const idx = list.findIndex((x) => x.id === sid);
        const j = idx + dir;
        if (j < 0 || j >= list.length) return;
        const tmp = list[idx]; list[idx] = list[j]; list[j] = tmp;
        const puts = [];
        for (let i = 0; i < list.length; i++) if (list[i].sort_index !== i) puts.push(api('/api/slots/' + list[i].id, { method: 'PUT', body: { sort_index: i } }));
        const results = await Promise.all(puts);
        const bad = results.find((r) => !r.ok);
        if (bad) { App.toast(App.errorText(bad.data), 'error'); reload(); return; }
        App.toast(t('mach_order_saved'));
        reload();
      }

      function startRename(mid, btn) {
        const m = state.machines.find((x) => x.id === mid);
        if (!m) return;
        const label = btn.closest('.m-label');
        label.innerHTML = `<input maxlength="64" value="${esc(m.alias || '')}" placeholder="${esc(m.label)}" style="width:min(240px,60vw)">
          <button class="btn sm primary" data-act="rename-save" data-mid="${mid}">${esc(t('save'))}</button>
          <button class="btn sm ghost" data-act="rename-cancel" data-mid="${mid}">${esc(t('cancel'))}</button>`;
        const input = label.querySelector('input');
        input.focus(); input.select();
        input.onkeydown = (ev) => {
          if (ev.key === 'Enter') { ev.preventDefault(); saveRename(mid, input.value); }
          else if (ev.key === 'Escape') { ev.preventDefault(); paint(); }
        };
      }
      async function saveRename(mid, value) {
        const r = await api('/api/machines/' + mid, { method: 'PUT', body: { alias: value.trim() } });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        App.toast(t('mach_renamed'));
        reload();
      }

      function openClaim(pcHash) {
        const form = document.createElement('div');
        form.className = 'stack';
        form.innerHTML = `<p class="muted small">${esc(t('mach_claim_desc'))}</p>
          <div class="panel"><span class="mono">${esc(hashShort(pcHash))}</span></div>
          <div class="field"><label for="claimAlias">${esc(t('mach_alias'))} <span class="faint">(${esc(t('optional'))})</span></label>
            <input id="claimAlias" maxlength="64" placeholder="${esc(t('mach_alias_ph'))}"></div>`;
        App.dialog({
          title: t('mach_claim_title'), body: form,
          actions: [
            { label: t('cancel'), kind: 'secondary' },
            { label: t('mach_claim_btn'), kind: 'primary', onClick: async () => {
              const alias = form.querySelector('#claimAlias').value.trim();
              const r = await api('/api/machine-pool/claim', { method: 'POST', body: { pc_hash: pcHash, alias: alias || undefined } });
              if (!r.ok) {
                App.toast(apiError(r, { already_claimed: 'mach_e_already_claimed' }), 'error');
                if (r.data && r.data.err === 'already_claimed') { reload(); return true; }
                return false;
              }
              App.toast(t('mach_claimed')); reload(); return true;
            } }
          ]
        });
      }

      async function dismiss(pcHash) {
        if (!await App.confirm({ title: t('mach_dismiss'), message: t('mach_dismiss_confirm'), confirm: t('delete'), danger: true })) return;
        const r = await api('/api/machine-pool/dismiss', { method: 'POST', body: { pc_hash: pcHash } });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        App.toast(t('mach_dismissed')); reload();
      }

      async function releaseMachine(mid) {
        const m = state.machines.find((x) => x.id === mid);
        if (!m) return;
        if (!await App.confirm({ title: t('mach_release'), message: t('mach_release_confirm', m.label || '', (m.slots || []).length), detail: t('mach_release_detail'), confirm: t('mach_release'), danger: true })) return;
        const r = await api('/api/machines/' + mid, { method: 'DELETE' });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        App.toast(t('mach_released')); reload();
      }

      async function deleteSlot(sid) {
        const s = findSlot(sid);
        if (!s) return;
        if (!await App.confirm({ title: t('mach_delete_slot'), message: t('mach_delete_slot_confirm', s.game_account), detail: s.license ? t('mach_delete_slot_lic_detail') : undefined, confirm: t('delete'), danger: true })) return;
        const r = await api('/api/slots/' + sid, { method: 'DELETE' });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        App.toast(t('mach_slot_deleted')); reload();
      }

      function pwControl(edit, slot) {
        if (!edit) return `<input id="slPw" type="password" autocomplete="new-password" placeholder="${esc(t('mach_pw_add_ph'))}">`;
        const has = slot.has_password;
        return `<div class="small muted">${esc(has ? t('mach_pw_current_set') : t('mach_pw_current_none'))}</div>
          <div class="row">
            <label class="check"><input type="radio" name="pwmode" value="keep" checked> ${esc(t('mach_pw_keep'))}</label>
            <label class="check"><input type="radio" name="pwmode" value="set"> ${esc(t('mach_pw_set'))}</label>
            ${has ? `<label class="check"><input type="radio" name="pwmode" value="clear"> ${esc(t('mach_pw_clear'))}</label>` : ''}
          </div>
          <input id="slPw" class="hidden" type="password" autocomplete="new-password" placeholder="${esc(t('mach_pw_new_ph'))}">`;
      }

      async function slotSuggest() {
        const servers = new Set();
        const byAccount = {};
        for (const m of state.machines) for (const s of (m.slots || [])) if (s.server_name) servers.add(s.server_name);
        try {
          const r = await api('/api/characters', { query: { limit: 200 } });
          for (const c of ((r.data && r.data.characters) || [])) {
            if (c.server_name) servers.add(c.server_name);
            const acc = (c.game_account || '').toLowerCase();
            if (acc && c.name) (byAccount[acc] = byAccount[acc] || new Set()).add(c.name);
          }
        } catch (_) {}
        return { servers: [...servers].sort(), byAccount };
      }

      async function slotDialog(opts) {
        const edit = !!opts.slot, slot = opts.slot;
        const sug = await slotSuggest();
        const nickFor = (acc) => [...(sug.byAccount[(acc || '').toLowerCase()] || [])].sort().map((n) => `<option value="${esc(n)}">`).join('');
        const srvOpts = sug.servers.map((s) => `<option value="${esc(s)}">`).join('');
        const curAcc = edit ? slot.game_account : (opts.email || '');
        const form = document.createElement('form');
        form.className = 'stack';
        form.innerHTML = `
          <div class="banner info"><span aria-hidden="true">ℹ️</span><span>${esc(edit ? t('mach_keep_note') : t('mach_add_note'))}</span></div>
          <div class="field" data-f="account">
            <label for="slAcc">${esc(t('mach_f_account'))}</label>
            <input id="slAcc" type="email" autocomplete="off" value="${esc(edit ? slot.game_account : (opts.email || ''))}" placeholder="name@example.com">
            <div class="hint">${esc(t('mach_f_account_hint'))}</div><div class="error"></div>
          </div>
          <div class="form-grid">
            <div class="field"><label for="slSrv">${esc(t('mach_f_server'))} <span class="faint">(${esc(t('optional'))})</span></label>
              <input id="slSrv" list="slSrvList" autocomplete="off" value="${esc(edit ? (slot.server_name || '') : '')}">
              <datalist id="slSrvList">${srvOpts}</datalist></div>
            <div class="field"><label for="slNick">${esc(t('mach_f_nickname'))} <span class="faint">(${esc(t('optional'))})</span></label>
              <input id="slNick" list="slNickList" autocomplete="off" value="${esc(edit ? (slot.nickname || '') : '')}">
              <datalist id="slNickList">${nickFor(curAcc)}</datalist>
              <div class="hint">${esc(t('mach_f_nickname_hint'))}</div></div>
          </div>
          <div class="field" data-f="pw"><label>${esc(t('mach_f_password'))}</label>${pwControl(edit, slot)}<div class="hint">${esc(t('mach_pw_hint'))}</div><div class="error"></div></div>
          <div class="field"><label for="slNote">${esc(t('mach_f_note'))} <span class="faint">(${esc(t('optional'))})</span></label><input id="slNote" maxlength="200" value="${esc(edit ? (slot.note || '') : '')}"></div>
          <label class="switch"><input type="checkbox" id="slEnabled"${(edit ? slot.enabled : true) ? ' checked' : ''}><span>${esc(t('mach_f_enabled'))}</span></label>`;
        if (edit) form.querySelectorAll('input[name=pwmode]').forEach((r) => r.addEventListener('change', () => {
          const show = form.querySelector('input[name=pwmode]:checked').value === 'set';
          const el = form.querySelector('#slPw');
          el.classList.toggle('hidden', !show);
          if (show) el.focus();
        }));
        form.querySelector('#slAcc').addEventListener('input', () => {
          const dl = form.querySelector('#slNickList');
          if (dl) dl.innerHTML = nickFor(form.querySelector('#slAcc').value);
        });

        const dlg = App.dialog({
          title: edit ? t('mach_slot_edit_title') : t('mach_slot_add_title'), body: form,
          actions: [{ label: t('cancel'), kind: 'secondary' }, { label: edit ? t('save') : t('add'), kind: 'primary', onClick: submit }]
        });
        form.addEventListener('submit', (e) => { e.preventDefault(); const b = dlg.el.querySelector('.dialog-foot .btn.primary'); if (b && !b.disabled) b.click(); });

        async function submit() {
          const accField = form.querySelector('[data-f=account]'), pwField = form.querySelector('[data-f=pw]');
          const accEl = form.querySelector('#slAcc'), acc = accEl.value.trim().toLowerCase();
          const setErr = (field, msg) => { field.classList.add('invalid'); field.querySelector('.error').textContent = msg; };
          const clear = (field) => { field.classList.remove('invalid'); field.querySelector('.error').textContent = ''; };
          clear(accField); clear(pwField);
          if (!acc) { setErr(accField, t('mach_v_account_required')); accEl.focus(); return false; }
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(acc)) { setErr(accField, t('mach_v_account_email')); accEl.focus(); return false; }
          const body = {
            game_account: acc,
            server_name: form.querySelector('#slSrv').value.trim(),
            nickname: form.querySelector('#slNick').value.trim(),
            note: form.querySelector('#slNote').value.trim(),
            enabled: form.querySelector('#slEnabled').checked
          };
          if (edit) {
            const mode = form.querySelector('input[name=pwmode]:checked').value;
            if (mode === 'set') {
              const pw = form.querySelector('#slPw').value;
              if (!pw) { setErr(pwField, t('mach_v_password_required')); form.querySelector('#slPw').focus(); return false; }
              body.password = pw;
            } else if (mode === 'clear') body.clear_password = true;
          } else {
            const pw = form.querySelector('#slPw').value;
            if (pw) body.password = pw;
          }
          const r = edit ? await api('/api/slots/' + slot.id, { method: 'PUT', body })
            : await api('/api/machines/' + opts.mid + '/slots', { method: 'POST', body });
          if (!r.ok) {
            if (r.data && r.data.err === 'slot_exists') { setErr(accField, t('mach_e_slot_exists')); accEl.focus(); return false; }
            App.toast(App.errorText(r.data), 'error'); return false;
          }
          App.toast(edit ? t('mach_slot_saved') : t('mach_slot_added'));
          reload(); return true;
        }
      }

      function openLicensePicker(slot) {
        const dlg = App.dialog({ title: t('mach_lic_pick_title'), body: `<div class="skeleton" style="height:100px"></div>`, actions: [{ label: t('close'), kind: 'secondary' }] });
        loadPicker();
        async function loadPicker() {
          const r = await api('/api/licenses');
          const lics = (r.data && r.data.licenses) || [];
          const bindable = lics.filter((l) => ['unused', 'waiting', 'active'].includes(l.status));
          const cur = slot.license;
          let html = `<p class="muted small">${esc(t('mach_lic_pick_desc'))}</p>`;
          if (cur) html += `<div class="panel row between"><div class="grow"><div class="row"><code class="mono">${esc(cur.key_hint)}</code>${App.licenseBadge(cur)}</div>
            <div class="small muted">${esc(t('mach_lic_current_slot'))}</div></div><button class="btn sm danger" data-unbind="1">${esc(t('mach_lic_unbind'))}</button></div>`;
          if (!bindable.length && !cur) {
            html += `<div class="empty-state"><div class="empty-icon">🔑</div><p>${esc(t('mach_lic_none_available'))}</p><a class="btn secondary" href="#/licenses">${esc(t('mach_lic_go'))}</a></div>`;
          } else {
            html += bindable.map((l) => {
              const onThis = cur && cur.id === l.id;
              const where = onThis ? t('mach_lic_on_this')
                : (l.slot ? t('mach_lic_on_other_at', l.slot.machine_label, l.slot.game_account) : t('lic_unused'));
              const right = onThis ? `<span class="badge ok">${esc(t('mach_lic_on_this_badge'))}</span>`
                : `<button class="btn sm primary" data-bind="${l.id}">${esc(l.slot ? t('mach_lic_move_here') : t('mach_lic_connect'))}</button>`;
              return `<div class="panel row between"><div class="grow"><div class="row"><code class="mono">${esc(l.key_hint)}</code>${App.licenseBadge(l)}</div>
                <div class="small muted">${esc(where)}</div></div>${right}</div>`;
            }).join('');
          }
          dlg.body.innerHTML = html;
          dlg.body.querySelectorAll('[data-bind]').forEach((b) => b.onclick = () => bind(Number(b.dataset.bind)));
          const ub = dlg.body.querySelector('[data-unbind]');
          if (ub) ub.onclick = () => unbind();
        }
        async function bind(licId) {
          const r = await api('/api/slots/' + slot.id + '/license', { method: 'PUT', body: { license_id: licId } });
          if (!r.ok) { App.toast(apiError(r, { license_not_owned: 'mach_e_license_not_owned', license_revoked: 'mach_e_license_revoked', license_expired: 'mach_e_license_expired' }), 'error'); return; }
          App.toast(r.data && r.data.moved_from_slot_id ? t('mach_lic_moved') : t('mach_lic_bound_ok'));
          dlg.close(true); reload();
        }
        async function unbind() {
          const r = await api('/api/slots/' + slot.id + '/license', { method: 'PUT', body: { license_id: null } });
          if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
          App.toast(t('mach_lic_unbound')); dlg.close(true); reload();
        }
      }
    }
  });
})();
